export const DOMAIN_DEMO_NAME = 'lp2-dev.senetpro.com';
export const DOMAIN_DEMO_NAME_API = '148.113.193.136:20443';
export const DOMAIN_DEMO_API = 'http://'+DOMAIN_DEMO_NAME_API;
